import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import { Field } from '../../../../Field'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import Text from '../../../../Text'
import {
  FLAT_FORM_FIELD_NAME_SHARE,
  FLAT_FORM_FIELD_NAME_TOTAL,
} from '../../FlatForm.constants'

import * as styles from './PropertyShareField.module.css'

function PropertyShareField() {
  const { t } = useTranslation()

  const { isSubmitting } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <Field
      shouldAdaptToMobileScreen
      className={styles.PropertyShareField}
      disabled={isSubmitting}
      label={`${t('Flat.PropertyShareLabelKey')}:`}
    >
      <FormikField
        Component={InputField}
        Field={Fragment}
        borderless={!isMobileScreenSize}
        name={FLAT_FORM_FIELD_NAME_SHARE}
        placeholder={t('Flat.PropertySharePartPlaceholderKey')}
        type='number'
        wrapperClassName={styles.inputShare}
      />
      <Text isSecondary className={styles.divider}>
        /
      </Text>
      <FormikField
        Component={InputField}
        Field={Fragment}
        borderless={!isMobileScreenSize}
        name={FLAT_FORM_FIELD_NAME_TOTAL}
        placeholder={t('Flat.PropertyShareWholePlaceholderKey')}
        type='number'
        wrapperClassName={styles.inputTotal}
      />
    </Field>
  )
}

export default PropertyShareField
